import { Pipe, PipeTransform } from '@angular/core';
import { ISelected } from '@shared/models';

@Pipe({
    name: 'selectionChecker',
    standalone: false
})
export class SelectionCheckerPipe implements PipeTransform {

  transform(questionId: number, currentSelections: ISelected[]): unknown {
    if(!currentSelections) return false;
    return currentSelections.some(selection => selection.Id === questionId);
  }

}
